"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButton = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const react_intl_1 = require("react-intl");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const prompt_register_hook_1 = require("../prompt/prompt-register-hook");
const prompt_context_1 = require("../prompt/prompt-context");
const snackbar_context_1 = require("../snackbar/snackbar-context");
const snackbar_types_1 = require("../snackbar/snackbar-types");
const action_button_result_dialog_1 = require("./common/action-button-result-dialog");
function ActionButton({ promptKey, buttonLabel, buttonTooltip, buttonDisabled = false, dialogText, dialogTitle, dialogWidth, FormFields, formValidationSchema, formInitialValues, successMessage, errorMessage, apiCall, onSuccess, onSetLoading = lodash_1.noop, onError, onResult: providedOnResult, onShouldShow = lodash_1.stubTrue, ButtonComponent = ActionButtonComponent, buttonProps, resultDialog, ...restProps }) {
    const intl = react_intl_1.useIntl();
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const { testPrompt } = react_1.useContext(prompt_context_1.PromptContext);
    const fetch = react_1.useRef(null);
    const resultDialogRef = react_1.useRef(null);
    prompt_register_hook_1.usePrompts([
        {
            key: promptKey,
            dialogTitle,
            dialogText,
            dialogWidth,
            FormFields,
            formValidationSchema,
            formInitialValues,
        },
    ], [
        promptKey,
        dialogTitle,
        dialogText,
        dialogWidth,
        FormFields,
        formValidationSchema,
        formInitialValues,
    ]);
    const defaultOnResult = event_callback_hook_1.useEventCallback(() => {
        const message = successMessage !== null && successMessage !== void 0 ? successMessage : intl.formatMessage({
            id: 'EAS_ACTION_BUTTON_MSG_SUCCESS',
            defaultMessage: 'Akce byla úspěšně vykonána.',
        });
        showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
    });
    const defaultOnSuccess = event_callback_hook_1.useEventCallback(async () => {
        // nothing
    });
    const handleError = onError !== null && onError !== void 0 ? onError : defaultOnError;
    const handleSuccess = onSuccess !== null && onSuccess !== void 0 ? onSuccess : defaultOnSuccess;
    const handleResultDialogClose = event_callback_hook_1.useEventCallback(async () => {
        await handleSuccess();
    });
    const wrappedApiCall = event_callback_hook_1.useEventCallback(async (formData) => {
        var _a;
        try {
            onSetLoading(true);
            if (fetch.current !== null) {
                fetch.current.abort();
            }
            fetch.current = apiCall(formData);
            const response = await fetch.current.raw();
            if (providedOnResult !== undefined) {
                const json = await response.json();
                await providedOnResult(json);
            }
            else {
                defaultOnResult();
            }
            onSetLoading(false);
            if (resultDialog !== undefined) {
                // open result dialog if provided
                const data = await response.json();
                (_a = resultDialogRef.current) === null || _a === void 0 ? void 0 : _a.open(data);
            }
            else {
                // otherwise call success callback
                await handleSuccess();
            }
        }
        catch (err) {
            onSetLoading(false);
            if (err.name !== 'AbortError') {
                const message = errorMessage !== undefined
                    ? errorMessage.replace('{detail}', err.message)
                    : intl.formatMessage({
                        id: 'EAS_DETAIL_ACTION_FINISH_ERROR',
                        defaultMessage: 'Chyba volání akce: {detail}',
                    }, { detail: err.message });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                await handleError(err);
            }
            return undefined;
        }
    });
    const handleConfirm = event_callback_hook_1.useEventCallback(async () => {
        testPrompt({
            key: promptKey,
            callback: wrappedApiCall,
        });
    });
    const RawActionButtonComponent = (ButtonComponent !== null && ButtonComponent !== void 0 ? ButtonComponent : ActionButtonComponent);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        onShouldShow() && (react_1.default.createElement(RawActionButtonComponent, Object.assign({}, buttonProps, { disabled: buttonDisabled, label: buttonLabel, tooltip: buttonTooltip, onClick: handleConfirm }, restProps))),
        resultDialog !== undefined && (react_1.default.createElement(action_button_result_dialog_1.ActionButtonResultDialog, Object.assign({}, resultDialog, { ref: resultDialogRef, onClose: handleResultDialogClose })))));
}
exports.ActionButton = ActionButton;
async function defaultOnError(err) {
    throw err;
}
function ActionButtonComponent(props) {
    return react_1.default.createElement(Button_1.default, { onClick: props.onClick }, props.label);
}
//# sourceMappingURL=action-button.js.map